import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Icon } from '@modulor/react';
import Image from '../../../Image/Image';
import Skeleton from '../../../Skeleton/Skeleton';
import { useIsDesktopLayout } from '../../../../hooks/useIsDesktopLayout';
import withAnalytics from '../../../../hocs/withAnalytics';
import { useIsSSCOMBrand } from '../../../../hooks/useIsSSCOMBrand';
import { getDataTestAttrs } from '../../../../utils/testing-locators';
import {
  NAVIGATION_LINK,
  NAVIGATION_LINK_ICON,
  NAVIGATION_LINK_ARROW,
  NAVIGATION_LINK_GAME_COUNT,
} from '../../../../constants/dataTestIds';
import styles from './NavigationLink.module.css';

export const NavLinkWithAnalytics = withAnalytics(NavLink);

const NavigationLink = ({
  link,
  icon,
  title,
  gameCount,
  isLoading,
  className,
  analyticsData,
  ...props
}) => {
  const isDesktop = useIsDesktopLayout();
  const isSCCOMbrand = useIsSSCOMBrand();

  return isLoading ? (
    <Skeleton />
  ) : (
    <NavLinkWithAnalytics
      to={link}
      exact
      className={(isActive) =>
        classNames(
          styles.link_ig,
          isSCCOMbrand && styles.link_ig_sccom,
          isActive && styles.active_ig,
          className
        )
      }
      analyticsData={analyticsData}
      {...getDataTestAttrs(NAVIGATION_LINK, link)}
      {...props}
    >
      <span className={styles.container_ig}>
        <span
          className={styles.icon_ig}
          {...getDataTestAttrs(NAVIGATION_LINK_ICON)}
        >
          {isValidElement(icon) ? (
            icon
          ) : (
            <Image src={icon} fallback={<Icon name="no_icon" />} />
          )}
        </span>
        <span className={styles.title_ig}>{title}</span>
        {gameCount && (
          <span
            className={styles.count_ig}
            {...getDataTestAttrs(NAVIGATION_LINK_GAME_COUNT)}
          >
            {gameCount}
          </span>
        )}
        {!isDesktop && (
          <Icon
            name="chevron_right"
            className={styles.arrow_ig}
            {...getDataTestAttrs(NAVIGATION_LINK_ARROW)}
          />
        )}
      </span>
    </NavLinkWithAnalytics>
  );
};

NavigationLink.propTypes = {
  link: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
  gameCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  analyticsData: PropTypes.shape({
    schema: PropTypes.string,
    name: PropTypes.string,
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
    section_index: PropTypes.number,
    position_index: PropTypes.number,
    screen_area_detail: PropTypes.string,
  }),
};

NavigationLink.defaultProps = {
  isLoading: false,
  analyticsData: {},
};

export default NavigationLink;
